import {Record} from 'immutable';

const TypefaceSettings = Record({
  id: null,
  link: null,
  defaultSubsetting: '',
  characterSets: [],
});

export default TypefaceSettings;



// WEBPACK FOOTER //
// ./app/javascript/records/TypefaceSettings.js